
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosomnathjyotilingacab() {



    const cardData =
    {
        keyword: 'Pune to Somnath Jyotiling Cabs ',
        heading: 'Platinum24 Cabs: Pune to Somnath Jyotiling Cabs',
        headingDescription: ' Platinum24 Cabs offers dependable Pune to Somnath Jyotirling cab services, designed for pilgrims and families seeking a safe and comfortable journey to one of India’s most sacred temples. Whether you’re planning a spiritual darshan at the Somnath Jyotirling Temple, visiting nearby attractions like Triveni Sangam or Gir National Park, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a smooth travel experience. With professional chauffeurs, punctual pickups, and transparent pricing, we make your pilgrimage stress-free and convenient. From one-way rides to customized return packages, Platinum24 Cabs guarantees a reliable and memorable Pune to Somnath Jyotirling trip.',

        top: 'Top Places to Visit in Somnath with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Somnath Jyotirlinga Temple",
    "description": "The Somnath Temple, one of the 12 Jyotirlingas, is the spiritual heart of the town. Rebuilt several times after invasions, its current form is a majestic Chalukya-style structure facing the Arabian Sea. The temple is believed to be originally built by the Moon God. Evening aartis and the light-and-sound show narrate its history. Pilgrims believe darshan here grants liberation. Somnath Jyotirlinga is India’s eternal shrine of Lord Shiva."
  },
  {
    "title": "Triveni Sangam",
    "description": "Triveni Sangam is the confluence of three holy rivers – Hiran, Kapila, and Saraswati – meeting the Arabian Sea. Devotees take ritual baths here, as it is believed to purify sins. The ghat is especially crowded during Shivratri and Kartik Purnima. The peaceful surroundings add spiritual charm. It is also associated with Lord Krishna’s last journey. Triveni Sangam is Somnath’s sacred riverside landmark."
  },
  {
    "title": "Bhalka Tirth",
    "description": "Bhalka Tirth is a revered site where Lord Krishna was struck by an arrow, marking his departure from earth. A temple dedicated to Krishna stands here, drawing thousands of pilgrims. The spot has deep spiritual significance in Hindu mythology. The temple’s simplicity enhances its serenity. Devotees feel connected to Krishna’s divine journey. Bhalka Tirth is Somnath’s spiritual site of Krishna’s nirvana."
  },
  {
    "title": "Prabhas Patan Museum",
    "description": "Prabhas Patan Museum preserves artifacts, sculptures, and relics of Somnath’s glorious past. Exhibits include remains of ancient temples destroyed by invaders. Stone carvings, inscriptions, and coins narrate the temple’s history. Scholars and pilgrims find it enriching. The museum adds cultural depth to the pilgrimage. It is Somnath’s heritage treasure house."
  },
  {
    "title": "Gita Mandir",
    "description": "Gita Mandir, built by the Birla family, is dedicated to Lord Krishna and the Bhagavad Gita. The temple’s marble walls have all 700 verses of the Gita inscribed on them. Its serene environment attracts pilgrims and tourists alike. The architecture is simple yet elegant. Evening prayers create a divine atmosphere. Gita Mandir is Somnath’s tribute to Krishna’s wisdom."
  },
  {
    "title": "Somnath Beach",
    "description": "Somnath Beach, located near the temple, is a calm coastal stretch ideal for relaxation. Pilgrims often stroll here after darshan. The waves crashing near the temple backdrop create a spiritual ambiance. Street vendors sell snacks and souvenirs along the shore. Sunsets at the beach are mesmerizing. Somnath Beach is the town’s natural seaside retreat."
  },
  {
    "title": "Junagadh Gate",
    "description": "Junagadh Gate is one of the historic gateways of Somnath, built during invasions and temple reconstructions. It narrates stories of resilience and rebuilding. The gate is an example of old fortification architecture. Visitors often stop to admire its heritage value. It stands as a reminder of Somnath’s turbulent yet glorious history. Junagadh Gate is the town’s historic monument of endurance."
  },
  {
    "title": "Suraj Mandir",
    "description": "Suraj Mandir, dedicated to the Sun God, is one of Somnath’s ancient temples. Located near Triveni Ghat, it reflects the region’s solar worship traditions. Though partially in ruins, its carvings and structure remain attractive. Pilgrims include it in their temple visits. Its history dates back centuries. Suraj Mandir is Somnath’s ancient spiritual gem."
  },
  {
    "title": "Veneshwar Mahadev Temple",
    "description": "Veneshwar Mahadev Temple, located near the Somnath complex, is dedicated to Lord Shiva. Legends say it was built to protect the main Somnath shrine from invaders. The temple’s peaceful ambiance attracts devotees seeking blessings. Though smaller, it has deep local significance. It is often visited before or after darshan at Somnath. Veneshwar Mahadev is the town’s protective shrine of devotion."
  },
  {
    "title": "Ahilyabai Temple",
    "description": "Ahilyabai Temple was built by Queen Ahilyabai Holkar in the 18th century when the Somnath shrine was repeatedly destroyed. It served as the primary place of worship for devotees during that time. The temple still stands as a symbol of faith and resilience. Pilgrims admire its historical and religious significance. It preserves a chapter of Somnath’s revival. Ahilyabai Temple is the town’s sacred monument of devotion."
  }
],


                       "services": [
    {
      "name": "Pune to Somnath Cab",
      "description": "Embark on a serene journey from Pune to the sacred city of Somnath with our reliable Pune to Somnath Cab service. Designed for pilgrims, tourists, and travelers alike, our service ensures a comfortable and safe ride throughout this long-distance trip. Our fleet includes well-maintained, air-conditioned vehicles, driven by professional chauffeurs experienced in highway and rural routes. Enjoy the flexibility of customized pick-up and drop-off points, along with real-time vehicle tracking and 24/7 customer support. Whether traveling solo or with family, we prioritize your comfort, safety, and convenience on this spiritually significant journey."
    },
    {
      "name": "Book Pune to Somnath Jyotirling Cab",
      "description": "Easily book your taxi for a pilgrimage to the revered Somnath Jyotirling through our hassle-free online platform. Our Pune to Somnath Jyotirling Cab service caters especially to devotees looking for safe and timely transport to the temple. Choose from a variety of vehicles, including sedans and SUVs, suited for family or group travel. Our drivers are courteous and well-versed with the local routes, ensuring a smooth trip. With instant booking confirmation, transparent pricing, and dedicated customer support, your spiritual journey becomes stress-free and memorable."
    },
    {
      "name": "Pune to Somnath Temple Taxi",
      "description": "Our Pune to Somnath Temple Taxi service is designed to offer convenient transportation directly to the temple complex and nearby pilgrimage sites. Ideal for devotees seeking a peaceful and hassle-free trip, this service provides timely pickups and drop-offs with vehicles equipped for comfort and long-distance travel. We ensure strict vehicle hygiene and safety protocols to make your pilgrimage both safe and pleasant. Our chauffeurs can also suggest local spots to visit around Somnath, enhancing your spiritual experience with cultural immersion."
    },
    {
      "name": "Pune to Somnath One Way Cab",
      "description": "Opt for our Pune to Somnath One Way Cab service if you need cost-effective and convenient travel in a single direction. Perfect for pilgrims or travelers planning onward journeys from Somnath, this service offers flexible pickup and drop-off times with well-maintained vehicles driven by experienced chauffeurs. Transparent fare policies and real-time assistance ensure a smooth and stress-free experience. Choose this option to avoid the hassle of round-trip bookings while still enjoying high-quality service."
    },
    {
      "name": "Cab from Pune to Somnath",
      "description": "Our Cab from Pune to Somnath service offers dependable and comfortable travel options to suit your schedule and budget. Whether for spiritual purposes, family trips, or leisure visits, our diverse fleet ensures availability of vehicles from compact cars to spacious SUVs. Each vehicle is regularly serviced and sanitized for your safety. With professional drivers familiar with the route and highway conditions, your journey will be smooth and enjoyable. We also provide convenient booking channels and 24/7 customer support for a hassle-free experience."
    },
    {
      "name": "Pune to Somnath Pilgrimage Taxi",
      "description": "Make your pilgrimage journey stress-free with our Pune to Somnath Pilgrimage Taxi, specially tailored for devotees traveling to the holy Jyotirlinga temple. Our service focuses on providing peaceful, punctual, and safe rides, with vehicles equipped for long-distance travel comfort. We offer customizable trip plans, allowing you to schedule temple visits and explore nearby sacred sites. Our professional drivers respect the sanctity of your journey, ensuring a tranquil atmosphere on the road while maintaining high standards of safety and hospitality."
    },
    {
      "name": "Pune to Somnath Jyotirling Darshan Cab",
      "description": "Plan your Jyotirling Darshan trip effortlessly with our Pune to Somnath Jyotirling Darshan Cab service. We understand the spiritual significance of this pilgrimage and provide vehicles that cater to groups and families seeking comfort and reliability. Our chauffeurs have extensive knowledge of the routes and local culture, making stops as needed and assisting with any special requirements. With transparent pricing, flexible booking options, and dedicated support, your pilgrimage becomes a seamless and memorable experience."
    },
    {
      "name": "Pune to Somnath Car Hire",
      "description": "Enjoy the freedom to travel at your own pace with our Pune to Somnath Car Hire service. Perfect for travelers who prefer flexibility, choose from self-drive or chauffeur-driven car rentals equipped with modern amenities. Our vehicles are regularly maintained and sanitized to ensure a clean and safe environment. Whether you’re planning a quick visit or an extended stay, our rental options come with competitive pricing, straightforward booking, and excellent customer service to make your journey as comfortable and convenient as possible."
    },
    {
      "name": "Somnath to Pune Taxi",
      "description": "For your return journey, our Somnath to Pune Taxi service guarantees timely and comfortable rides back to Pune. Our professional drivers provide courteous and safe transportation with well-maintained vehicles suited for long-distance travel. Whether you require a prompt airport transfer or a relaxed trip back home, our service ensures flexibility and transparency in booking and fare. We focus on delivering reliable rides that fit your schedule and travel preferences."
    },
    {
      "name": "Pune to Somnath Taxi Fare",
      "description": "Get clear and competitive fare estimates with our Pune to Somnath Taxi Fare details. We offer transparent pricing based on distance, vehicle type, and any additional services requested. Our fare structure avoids hidden charges, ensuring you know exactly what you pay. Discounts on early bookings and special pilgrimage packages make traveling more affordable. For personalized fare information or bulk bookings for groups, our customer care team is always available to assist you."
    }
  ],
  "tableData": [
    ["Pune to Somnath Cab", "Book Pune to Somnath Jyotirling Cab"],
    ["Pune to Somnath Temple Taxi", "Pune to Somnath One Way Cab"],
    ["Cab from Pune to Somnath", "Pune to Somnath Pilgrimage Taxi"],
    ["Pune to Somnath Jyotirling Darshan Cab", "Pune to Somnath Car Hire"],
    ["Somnath to Pune Taxi", "Pune to Somnath Taxi Fare"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Pune to Somnath Jyotiling Cab Service",
    "WhyChoosedescription": "Platinum24 Cabs offers reliable and comfortable cab services for your journey from Pune to Somnath Jyotiling, ensuring a smooth and pleasant travel experience."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Your Group",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers tailored to your travel needs for Pune to Somnath Jyotiling trips."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Cabs for Safe Travel",
    "WhyChoosedescription": "All vehicles are regularly cleaned and sanitized to provide a safe and hygienic environment during your Pune to Somnath Jyotiling journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Routes",
    "WhyChoosedescription": "Our professional drivers know the best routes between Pune and Somnath Jyotiling to ensure timely and smooth travel."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy transparent fares including tolls, fuel, and driver allowances for hassle-free Pune to Somnath Jyotiling cab service."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist you with bookings and travel queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages Tailored to Your Needs",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term rental plans customized for your Pune to Somnath Jyotiling travel."
  },
  {
    "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your Pune to Somnath Jyotiling cab quickly and securely through our website or app with immediate confirmation."
  }
]



























    }

    
const faqData = [
    {
        question: 'Does Platinum24 Cabs provide Pune to Somnath Jyotiling cab services?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services from Pune to Somnath Jyotiling with professional drivers and well-maintained vehicles.',
    },
    {
        question: 'How can I book a cab from Pune to Somnath Jyotiling?',
        answer: 'You can book your cab easily through our website, mobile app, or by contacting our 24x7 customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Somnath Jyotiling travel?',
        answer: 'We provide hatchbacks, sedans, SUVs, and luxury cars to suit your preferences and group size.',
    },
    {
        question: 'Is one-way cab service available from Pune to Somnath Jyotiling?',
        answer: 'Yes, both one-way and round-trip cab services are available for Pune to Somnath Jyotiling travel.',
    },
    {
        question: 'Are the drivers experienced for Pune to Somnath Jyotiling long-distance trips?',
        answer: 'Absolutely, our drivers are licensed, professional, and familiar with the Pune to Somnath Jyotiling route.',
    },
    {
        question: 'Can I customize pickup and drop-off locations in Pune and Somnath Jyotiling?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points for your convenience.',
    },
    {
        question: 'What safety and hygiene protocols are followed for Pune to Somnath Jyotiling cabs?',
        answer: 'All vehicles are regularly sanitized, and drivers adhere to strict safety and hygiene measures to ensure passenger safety.',
    },
    {
        question: 'Is Pune to Somnath Jyotiling cab service available 24x7?',
        answer: 'Yes, Platinum24 Cabs operates 24x7 for Pune to Somnath Jyotiling cab bookings.',
    },
    {
        question: 'What payment options are accepted for Pune to Somnath Jyotiling cab bookings?',
        answer: 'We accept cash, digital wallets, UPI, and major credit/debit cards for hassle-free payments.',
    },
    {
        question: 'Are customizable packages available for Pune to Somnath Jyotiling cab service?',
        answer: 'Yes, we offer flexible and customizable packages tailored to your travel itinerary and preferences.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Vikram Desai',
        feedback: 'The Pune to Somnath Jyotiling cab service was excellent. Comfortable ride and professional driver.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Meera Shah',
        feedback: 'Highly satisfied with the punctuality and service quality of Platinum24 Cabs for my Pune to Somnath Jyotiling trip.',
        rating: 5,
    },
];















































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const puneToSomnathCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Somnath Jyotiling Cab Service",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-somnath-cab.jpg",
  "description": "Book Pune to Somnath Jyotiling cab service with Platinum24 Cabs. Comfortable and reliable taxis available for pilgrimage trips, one-way rides, and round trips. Safe, affordable, and available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "32150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "10999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-somnath-cab-service"
  }
};







    return (
        <div>

<Helmet>
  <title>Pune to Somnath Jyotiling Cab Service | Pilgrimage Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Somnath Jyotiling cab service with Platinum24 Cabs. Comfortable and reliable taxis available for pilgrimage trips, one-way rides, and round trips. Safe, affordable, and available 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Somnath Cab, Book Pune to Somnath Jyotirling Cab, Pune to Somnath Temple Taxi, Pune to Somnath One Way Cab, Cab from Pune to Somnath, Pune to Somnath Pilgrimage Taxi, Pune to Somnath Jyotirling Darshan Cab, Pune to Somnath Car Hire, Somnath to Pune Taxi, Pune to Somnath Taxi Fare"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToSomnathCabSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/112.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetosomnathjyotilingacab;